var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00049 1.54358C2.00049 3.25281 3.48296 4.63763 5.31082 4.63763C7.13867 4.63763 8.62115 3.25281 8.62115 1.54358",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62115 1.6034C8.62115 2.21251 7.13867 2.70685 5.31082 2.70685C3.48296 2.70685 2.00049 2.21251 2.00049 1.6034C2.00049 0.994304 3.48296 0.499961 5.31082 0.499961C7.13867 0.499961 8.62115 0.994304 8.62115 1.6034Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15779 6.66991C2.184 7.22384 1.32166 8.09446 0.783179 9.11404C0.420698 9.80038 0.692697 10.7251 1.33545 11.0362C2.52828 11.6139 4.01737 11.8103 5.31061 11.8103C6.60384 11.8103 8.09294 11.6139 9.28576 11.0362C9.92852 10.7251 10.2005 9.80038 9.83804 9.11404C9.30011 8.09611 8.43942 7.2266 7.46784 6.67267",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48641 4.13213L3.146 6.61267C3.146 6.61267 3.86765 7.39667 5.31095 7.39667C6.7537 7.39667 7.47481 6.61984 7.47481 6.61984L7.13494 4.13213",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99414 11.8104L5.31083 16.5L5.62697 11.8104",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pinIcon.b0fa8b4cae479dfd0f6aff9996a9a4cd.svg";
export { ForwardRef as ReactComponent };